import { render, staticRenderFns } from "./EventUsersMassInviteDialog.vue?vue&type=template&id=23393126&scoped=true&"
import script from "./EventUsersMassInviteDialog.vue?vue&type=script&lang=js&"
export * from "./EventUsersMassInviteDialog.vue?vue&type=script&lang=js&"
import style0 from "./EventUsersMassInviteDialog.vue?vue&type=style&index=0&id=23393126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23393126",
  null
  
)

export default component.exports